module.exports = __webpack_public_path__ + "img/nwitrgb_2x.82f2db94.svg";